import { ChevronUp as CarbonChevronUp } from '@carbon/react/icons';
import { iconPropTypes, iconDefaultProps } from '../../types/prop-types/icons';

const getChevronUpIcon = (size = 16) => {
  const ChevronUpIcon = (props) => <CarbonChevronUp size={size} {...props} />;

  ChevronUpIcon.propTypes = iconPropTypes;
  ChevronUpIcon.defaultProps = iconDefaultProps;

  return ChevronUpIcon;
};

export const ChevronUp16 = getChevronUpIcon();
export const ChevronUp20 = getChevronUpIcon(20);
export const ChevronUp24 = getChevronUpIcon(24);
export const ChevronUp32 = getChevronUpIcon(32);
